export default __webpack_public_path__ + "static/media/nav-profile.9f0e3ec1.svg";